// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton_closeButton__cIobu","crossIcon":"CloseButton_crossIcon__kI5ty"};